<template>
  <div class="fill-height">
    <div class="fill-height d-flex flex-column justify-center align-center">
      <h1 class="text-h2 grey--text text--darken-3">
        Welcome to
        <span class="primary--text font-weight-thin">masterTime</span>
      </h1>
      <div
        v-if="user && user.email"
        class="mt-6"
        style="font-size: 28px; color: #555"
      >
        {{ user.email }}
      </div>
      <div
        v-else
        class="mt-6 d-flex flex-column align-center"
        style="font-size: 28px; color: #555"
      >
        <div>{{ user.fullName }}</div>
        <div>รหัส : {{ user.employee_code }}</div>
        <div>
          บทบาท :
          <span v-if="employeePolicy.personal_policy_uuid"
            ><v-chip
              color="cyan"
              text-color="white"
              small
              class="mr-2 my-1"
              :key="employeePolicy.employee_uuid"
            >
              ส่วนตัว
            </v-chip></span
          >
          <span v-if="employeePolicy.roles && employeePolicy.roles.length > 0">
            <v-chip
              small
              class="mr-2 my-1"
              v-for="role in employeePolicy.roles"
              :key="role.role_uuid"
            >
              {{ role.title }}
            </v-chip>
          </span>
          <span v-else>-</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'Home',
  created() {
    this.$store.commit('SET_BREADCRUMBS', [
      { text: 'หน้าหลัก', disabled: true },
    ])
  },
  computed: {
    user() {
      return this.$store.state.authentication.user
    },
    employeePolicy() {
      return this.$store.state.employeePolicy.employeePolicy
    },
  },
  created() {
    if (!this.user?.email) {
      this.loadDataApi()
    }
  },
  methods: {
    ...mapActions({
      getEmployeePolicy: 'employeePolicy/getEmployeePolicy',
    }),
    async loadDataApi() {
      try {
        const { company_uuid } = this.$store.state.authentication.company

        this.$store.state.loading = true

        const payload = {
          company_uuid,
          employee_uuid: this.user.uuid,
        }

        await this.getEmployeePolicy(payload)
      } catch (error) {
        const snackbar = {
          show: true,
          color: 'error',
          timeout: -1,
          message: error?.response?.data?.message || 'Something went wrong!',
        }
        this.$store.commit('SET_SNACKBAR', snackbar)
      } finally {
        this.$store.state.loading = false
      }
    },
  },
}
</script>
